import * as React from 'react';
import {Banner} from './banner';
import {Navbar} from './nav';
import {Footer} from './footer';
import {connect} from 'react-redux';
import {Toasts} from './toasts';


@connect(state => ({
    loading: state.ui.loading,
    messages: state.ui.messages,
    textForKey: state.data.textForKey
}))
export class App extends React.Component<any, any> {
    public static contextTypes: React.ValidationMap<any> = {
        history: React.PropTypes.object.isRequired,
        location: React.PropTypes.object.isRequired,
    };

    context: { history: ReactRouter.History, location: any };

    render() {
        const {loading, messages, textForKey, children, dispatch} = this.props;
        if (loading) {
            return <div className="loader"/>;
        }

        return (
            <section id="app">
                <Banner/>
                <Navbar/>
                <Toasts messages={messages} dispatch={dispatch}/>
                <section className="main-section">
                    {children}
                </section>
                <Footer/>
            </section>
        );
    }
}
